import classnames from '@helpers/misc/classnames'
import useInitialData from '@page-components/Layout/useInitialData'
import Link from 'next/link'
import {ORDER_PAGE} from './Links/comparePaths'

interface GoToOrderButtonProps {
  className?: string
  onClick?: (e) => void
}

function GoToOrderButton(props: GoToOrderButtonProps) {
  const {className, onClick} = props
  const {website} = useInitialData()
  const orderPage = website.navbarConfiguration?.links?.find(link => link.path === ORDER_PAGE)

  return (
    <Link
      href={ORDER_PAGE}
      className={classnames(
        'whitespace-nowrap text-sm orion_primary py-3.5 px-5 font-semibold rounded-lg w-fit',
        className,
      )}
      onClick={onClick}
    >
      {`${orderPage?.title ?? 'Pedir'}`}
    </Link>
  )
}

export default GoToOrderButton
